import React from 'react'
import LargestCollections from './LargestCollections'
import './MarketMove.css'
import TopArtists from './TopArtists'
import TopCollectors from './TopCollectors'


function MarketMove() {
    return (
        <div className="MarketMove">
            <h2 className="sectionHeading">Watch the market move</h2>
            <div className="MarketMoveItems">
                <TopCollectors
                    title = "Top Collectors"
                    subtitle = "recently collected"
                    viewPage = "/top-collectors"
                />
                <TopArtists
                    title = "Top Artists"
                    subtitle = "RECENT SALES"
                    viewPage = "/top-artists"
                />
                <LargestCollections
                    title = "Largest Collections"
                    subtitle = "ARTWORKS OWNED"
                    viewPage = "/largest-collections"
                />
            </div>
        </div>
    )
}

export default MarketMove
